import React from "react";

const Main = (props) => (
    <React.Fragment>
        {props.children}
    </React.Fragment>
)

export default Main